module.exports = __webpack_public_path__ + "static/media/imageBoxFont.b56002a5.png";